"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * css classes mapping
 * */
exports.styles = {
    menu: 'react-contexify',
    submenu: 'react-contexify react-contexify__submenu',
    submenuArrow: 'react-contexify__submenu-arrow',
    separator: 'react-contexify__separator',
    item: 'react-contexify__item',
    itemDisabled: 'react-contexify__item--disabled',
    itemContent: 'react-contexify__item__content',
    itemIcon: 'react-contexify__item__icon',
    theme: 'react-contexify__theme--',
    animationWillEnter: 'react-contexify__will-enter--',
    animationWillLeave: 'react-contexify__will-leave--'
};
exports.theme = {
    light: 'light',
    dark: 'dark'
};
exports.animation = {
    fade: 'fade',
    flip: 'flip',
    pop: 'pop',
    zoom: 'zoom'
};
//# sourceMappingURL=styles.js.map